import { render, staticRenderFns } from "./ProductOrderForm.vue?vue&type=template&id=37fbdb91&scoped=true"
import script from "./ProductOrderForm.vue?vue&type=script&lang=ts"
export * from "./ProductOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./ProductOrderForm.vue?vue&type=style&index=0&id=37fbdb91&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbdb91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fbdb91')) {
      api.createRecord('37fbdb91', component.options)
    } else {
      api.reload('37fbdb91', component.options)
    }
    module.hot.accept("./ProductOrderForm.vue?vue&type=template&id=37fbdb91&scoped=true", function () {
      api.rerender('37fbdb91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/ProductOrderForm.vue"
export default component.exports